import { JourneyPlace } from '../../lib/types/models/journey-place/journey-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type Input = {
  journeyId: number
  tripPlaceId: number
  mainTripId: number
  secondaryTripId?: number
}

export const getPlacesByTripPlaceAndSecondaryTripAndMainTrip = (input: Input) => {
  const { journeyId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.products.getPlacesByTripPlaceAndSecondaryTripAndMainTrip.url, {
          id: journeyId
        }),
        rest
      )
    )
    .get<JourneyPlace[]>()
}
